export default __webpack_public_path__ + "static/media/4.91f49474.JPG";